<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/newsletter.svg');
            background-position: top !important;
          "
        ></div>
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">
              {{ $t("subscribe_to_our_newsletter") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div class="pt-8">
      <div class="row disablerow align-items-start">
        <!-- Left Area -->
        <div class="col-xl-9 innercreatetraining subscription_news">
          <!-- confirm unsubscription -->
          <div class="sto_newsletter_popup">
            <img
              class="newsletter_v_arrow"
              src="/static/img/ev__close.png"
              alt="close"
            />
            <h3 class="align_center">{{ $t("you_have_been_unsubscribed") }}</h3>
            <p class="nl_p2">
              {{ $t("your_subscription_to") }} <br />
              {{ $t("successfully_canceled") }}
            </p>
            <p class="nl_p2">
              {{ $t("thank_you_for_being_part") }}
            </p>
            <p class="nl_p2">
              {{ $t("if_you_change_your_mind") }}
            </p>
            <p class="nl_p2">
            <span v-html="$t('if_you_unsubscribed_by_mistake', { email: '<a href=\'mailto:trainingacademy@knorr-bremse.com\'>trainingacademy@knorr-bremse.com</a>' })"></span>
<!-- 
              {{ $t("if_you_unsubscribed_by_mistake") }} <br />
              <a href="#">trainingacademy@knorr-bremse.com</a>. -->
            </p>
            <!-- <v-card-actions class="">
              <v-btn
                @click="cancelSubscription"
                outlined
                depressed
                tile
                class="savebutton"
              >
                {{ $t("browse_training_programs") }}</v-btn
              >
            </v-card-actions> -->
          </div>
        </div>
        <div class="col-xl-3 ml-1 px-0 pl-md-12 pl-lg-8 row pt-0 onlyContact">
          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Breadcrumb,
  },
  data() {
    message: "Hello Vue!";
  },
  mounted() {},
  methods: {
    cancelSubscription() {
      this.$router.push("/categories");
      window.location.reload();
    },
  },
};
</script>
